import { render } from "./EmojiPicker.vue?vue&type=template&id=01893dc4&scoped=true"
import script from "./EmojiPicker.vue?vue&type=script&lang=js"
export * from "./EmojiPicker.vue?vue&type=script&lang=js"

import "./EmojiPicker.vue?vue&type=style&index=0&id=01893dc4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-01893dc4"

export default script